<swal
  #deleteSwal>
  <ng-container *swalPortal="swalTargets.actions">
    <button *ngIf="showDeleteAllButton" type="button" 
      class="swal2-confirm" [ngClass]="customClass.confirmButton"
      (click)="deleteAllData($event)">
      {{deleteAllButtonText}}
    </button>

    <button *ngIf="options.showConfirmButton" type="button" 
      class="swal2-confirm" [ngClass]="customClass.confirmButton"
      (click)="deleteData($event)">
      {{options.confirmButtonText}}
    </button>

    <button *ngIf="options.showCancelButton" type="button" 
      class="swal2-cancel" [ngClass]="customClass.cancelButton"
      (click)="cancel($event)">
      {{options.cancelButtonText}}
    </button>
  </ng-container>
</swal>